import React, {FC, useState} from 'react';

import {utils} from '../utils';
import {svg} from '../assets/svg';
import {theme} from '../constants';

type Props = {
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  type?: 'text' | 'password' | 'email';
  clickable?: boolean;
  containerStyle?: React.CSSProperties;
  autoCapitalize?: 'none' | 'sentences' | 'words' | 'characters';
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  validateEmail?: boolean;
  showValidationIcon?: boolean;
  isPasswordField?: boolean;
};

export const InputField: FC<Props> = ({
  placeholder,
  containerStyle,
  autoCapitalize = 'none',
  leftIcon,
  rightIcon,
  clickable,
  type = 'text',
  value = '',
  onChange,
  validateEmail: validateEmailProp = false,
  showValidationIcon = false,
  isPasswordField = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e);
    }

    if (validateEmailProp) {
      setIsValidEmail(utils.validateEmail(e.target.value));
    }
  };

  const handlePasswordToggle = () => {
    if (isPasswordField) {
      setShowPassword(!showPassword);
    }
  };

  const shouldShowValidationIcon = validateEmailProp && showValidationIcon && isValidEmail;

  return (
    <div
      style={{
        height: 50,
        paddingLeft: 10,
        paddingRight: 20,
        position: 'relative',
        border: '1px solid #FFEFE6',
        backgroundColor: theme.colors.white,
        borderRadius: 10,
        ...utils.rowCenter(),
        ...containerStyle,
      }}
    >
      <div style={{marginRight: 14}}>{leftIcon}</div>
      <input
        className='input-field'
        autoCapitalize={autoCapitalize}
        placeholder={placeholder}
        maxLength={50}
        type={isPasswordField ? (showPassword ? 'text' : 'password') : type}
        value={value}
        onChange={handleInputChange}
        style={{
          width: '100%',
          height: '100%',
          padding: 0,
          margin: 0,
          border: 'none',
          outline: 'none',
          backgroundColor: 'transparent',
          fontSize: 16,
          color: theme.colors.mainDark,
          ...theme.fonts.SourceSansPro_400Regular,
        }}
      />
      {rightIcon && !clickable && !isPasswordField && shouldShowValidationIcon && (
        <div>{rightIcon}</div>
      )}
      {rightIcon && clickable && isPasswordField && (
        <button
          type='button'
          onClick={(e) => {
            e.preventDefault();
            handlePasswordToggle();
          }}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '0 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 'auto',
          }}
        >
          {showPassword ? <svg.EyeOffSvg /> : <svg.EyeOffSvg />}
        </button>
      )}
    </div>
  );
};
